import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import { useSelector } from "react-redux"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import { useParams } from "react-router-dom"
import { ALAPostocc, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction"
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react"
const ALApostoccupancy = ()=>{
  const {id,user} : any = useParams()
  const componentRef = useRef();
const [postocc,setpostocc] = useState(
  {
    offer_id: id,
    dated: null,
    legal_description: "",
    address: "",
    accupancy_fees: 0,
    day_each_month: "",
    ending_upon: "",
    pay_to_buyer: "",
    comments_for_single_family: "",
    pets_may_not: true,
    pets_may_keep: true,
    security_deposit: 0,
    comments_8: "",
    dated_this: "",
    day_of: "",
    day_of_: "",
    seller1_signature: "",
    seller2_signature: "",
    buyer1_signature: "",
    buyer2_signature: "",
    state_of_1: "",
    county_of_1: "",
    foregoing_agreement_1: "",
    seller_name1: "",
    seller_name2: "",
    notary_public_1: "",
    state_of_2: "",
    county_of_2: "",
    foregoing_agreement_2: "",
    buyer_name1: "",
    buyer_name2: "",
    notary_public_2: ""
  }
)
const [loader,setloading] = useState(false)
 // @ts-ignore
 const val = useSelector((state)=>state?.new?.signset)
const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [offerdetails, setOfferDetails] = useState({});
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid : "",
  document_name: "",
  image_base64: "",
  sign_role: 1
  })

  const printf = () => {
    // window.print()
    handlePrint()
};

useEffect(()=>{
  if(val){
    if(user == "seller"){
      setpostocc({ ...postocc, seller1_signature: val }) 
    }
    if(user == "client"){
      setpostocc({ ...postocc, buyer1_signature: val }) 
    }
  }
  },[val])
const send = async()=>{
  setloading(true)
  if(user === "seller"){
 
    if(postocc?.seller1_signature){
      let res = await ALAPostocc(postocc)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  else if(user === "client"){

    if(postocc?.buyer1_signature){
      let res = await ALAPostocc(postocc)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  setloading(false)
}


useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)
    setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"postoccupancy") 
    setpostocc({...postocc,
      legal_description: res?.data?.legal_description,
      address: res?.data?.address,
      accupancy_fees: res?.data?.accupancy_fees,
      day_each_month: res?.data?.day_each_month,
      dated: res?.data?.dated,
      ending_upon: res?.data?.ending_upon,
      pay_to_buyer: res?.data?.pay_to_buyer,
      comments_for_single_family: res?.data?.comments_for_single_family,
      pets_may_not: res?.data?.pets_may_not,
      pets_may_keep: res?.data?.pets_may_keep,
      security_deposit: res?.data?.security_deposit,
      comments_8: res?.data?.comments_8,
      dated_this: res?.data?.dated_this,
      day_of: res?.data?.day_of,
      day_of_: res?.data?.day_of_,
      seller1_signature: res?.data?.seller1_signature,
      seller2_signature: res?.data?.seller2_signature,
      buyer1_signature: res?.data?.buyer1_signature,
      buyer2_signature: res?.data?.buyer2_signature,
      state_of_1: res?.data?.state_of_1,
      county_of_1: res?.data?.county_of_1,
      foregoing_agreement_1: res?.data?.foregoing_agreement_1,
      seller_name1: res?.data?.seller_name1,
      seller_name2: res?.data?.seller_name2,
      notary_public_1: res?.data?.notary_public_1,
      state_of_2: res?.data?.state_of_2,
      county_of_2: res?.data?.county_of_2,
      foregoing_agreement_2: res?.data?.foregoing_agreement_2,
      buyer_name1: res?.data?.buyer_name1,
      buyer_name2: res?.data?.buyer_name2,
      notary_public_2: res?.data?.notary_public_2
    })
  })()
},[])

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});

    return (
        <>
        <>
  <section style={{ pageBreakAfter: "always" }} ref={componentRef}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                  <td>
                    <img
                      style={{ width: 30 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                      alt=""
                    />
                    <img
                      style={{ width: 50 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 700 }}>
              Agreement for Seller to Occupy After Closing
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              Buyer(s) and Seller(s) have agreed to the sale of the property
              (“Property”) described below under the Purchase Agreement
              (“Purchase Agreement”) dated{" "}
              <input
                type="date"
                value={postocc?.dated}
                onChange={(e)=>setpostocc({...postocc,dated:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              and Buyer(s) will occupy the house and grounds prior to closing of
              the sale. This Agreement shall apply to that occupancy.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              1. THE PROPERTY
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              Legal Description:
              <input
                type="text"
                value={postocc?.legal_description}
                onChange={(e)=>setpostocc({...postocc,legal_description:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 900
                }}
              />{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              The Address is:
              <input
                type="text"//@ts-ignore
                value={offerdetails?.propertyAddress}
                // onChange={(e)=>setpostocc({...postocc,address:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 920
                }}
              />{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              2. SELLER(S) DUTIES UNDER THIS AGREEMENT
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>Buyer(s) shall:</span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>a.</span> Pay
              an occupancy fee of ${" "}
              <input
                type="number"
                value={postocc?.accupancy_fees} // @ts-ignore
                onChange={(e)=>setpostocc({...postocc,accupancy_fees:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              per day or any part thereof on the
              <input
                type="text"
                value={postocc?.day_each_month}
                onChange={(e)=>setpostocc({...postocc,day_each_month:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              day of each month, and shall occupy beginning upon the closing
              date under the Purchase Agreement and ending upon
              <input
                type="date"
                value={postocc?.ending_upon}
                onChange={(e)=>setpostocc({...postocc,ending_upon:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              (date). This occupancy fee shall be collected and paid at the time
              of closing provided; however, that the fee collected at closing
              shall not be more than one month’s rent. In the event that
              occupancy shall be longer than one month, the next month’s rent
              shall be prepaid to the Buyer for each consecutive month, or
              prorated part thereof, on the same day as closing for each month
              following closing.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>b.</span> Pay
              ${" "}
              <input
                type="text"
                value={postocc?.pay_to_buyer}
                onChange={(e)=>setpostocc({...postocc,pay_to_buyer:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              to Buyer(s) as a security deposit against any damage that may
              occur to the Property during the occupancy (this deposit shall not
              be more than one month’s periodic rent). The security deposit
              shall be returned to the Seller(s), if the Seller(s) returns the
              Property in as good a condition as received, normal wear and tear
              excluded and the Seller(s) are not delinquent in rent.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>c.</span>{" "}
              Seller shall be responsible for normal maintenance and minor
              breakdowns including, but not limited to, lawn and landscape care,
              normal maintenance of plumbing, HVAC, carpeting, windows,
              appliances and any other normal maintenance and minor repairs to
              the Property, normal wear and tear excepted..
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>d.</span>Pay
              all of the utilities and services from the first day Seller is in
              the house, prorated to date of departure.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>e.</span>{" "}
              Maintain the house, repair leaks and keep all of its systems and
              appliances in good working order, and Seller(s) agrees to pay to
              Buyer(s) the cost to restore to its condition prior to closing,
              normal wear and tear excluded.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>f.</span>
              Maintain the grounds in a neat and tidy fashion.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>g.</span>{" "}
              Maintain all personal property of Buyer(s) in the same condition
              as it was at the beginning of the occupancy, normal wear and tear
              excepted.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section style={{ pageBreakAfter: "always" }}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>h.</span>
              Admit Buyer(s) or his agent to inspect the property at reasonable
              time.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>i.</span>Keep
              a renter’s policy for personal property and liability, and
              indemnify and hold harmless Buyer(s) from any claims for injury to
              property or persons not covered by insurance. If possible,
              Seller(s) shall name Buyer(s) as a co-insured or a beneficiary on
              such insurance policies. Liability policies shall have a minimum
              limit of $250,000 per occurrence.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>j.</span> Use
              of the property only as a single-family residence. People to be
              living in the property shall be;
              <br />
              <textarea
               value={postocc?.comments_for_single_family}
               onChange={(e)=>setpostocc({...postocc,comments_for_single_family:e.target.value})}
                style={{ width: "100%", height: 100, resize: "none" }}
                defaultValue={""}
              />
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>k.</span>Pay
              to Buyer(s) any costs of repair to the house and grounds for any
              damage not covered above
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>l.</span>
              Vacate the property within three (3) days following the
              termination of this agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>m.</span>Pay
              costs and attorney fees allowed by law for any action necessary by
              Buyer(s) to enforce this agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>n.</span>
              Except for normal maintenance and minor breakdowns, despite any
              language in this agreement to the contrary, Buyer(s) shall repair
              and replace any major breakdowns in the electrical systems, air
              systems, plumbing and repair and replace any major or structural
              items, except as shall be caused by the neglect, and willful
              misconduct or the failure of Seller(s) to perform the terms of
              this Agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>Buyer(s) shall not</span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>a.</span>Make
              any changes of any kind to the house or grounds without Buyer(s)
              prior written consent, and Seller(s) agrees to pay to Buyer(s) any
              reasonable cost to restore the property to its condition before
              the change.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>b.</span>
              Violate any laws, covenants, rules or regulations applying to the
              property.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>c.</span>Rent
              the property, assign this agreement or sublet the property.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>d.</span>Take
              any action that would cause a lien, judgment or encumbrance
              against the property.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              3.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                RISK OF LOSS.
              </span>
              Any risk of loss to personal property shall be borne by Buyer(s),
              from the date of occupancy to the time of closing. To the extent
              that this modifies the Purchase Agreement, this Agreement
              controls. The parties to this Agreement should consult their
              insurance agent.{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              4.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                PETS.{" "}
              </span>
              . Buyer(s)
              <input type="checkbox" 
               checked={postocc?.pets_may_not}
               onChange={(e)=>setpostocc({...postocc,pets_may_not:!postocc?.pets_may_not})}
              />
              May not <input type="checkbox" 
                checked={postocc?.pets_may_keep}
                onChange={(e)=>setpostocc({...postocc,pets_may_keep:!postocc?.pets_may_keep})}
              /> May keep domestic pet(s) on the
              property, and a security deposit of $ shall be paid for damage
              that the pet(s) may cause. If neither box is checked, the Buyer(s)
              may not keep pets of any kind. This security deposit shall be paid
              to Seller(s) directly and returned to Buyer(s) should the property
              be returned in as good a condition as received. In the event any
              damage or clean-up is needed beyond ordinary wear and tear, said
              security deposit may be used toward such costs and the balance
              returned to the Buyer(s).{" "}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section style={{ pageBreakAfter: "always" }}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              5.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                DEFAULT.{" "}
              </span>
              If Seller(s) fails to do anything required of him under this
              Agreement, Buyer(s) may terminate this Agreement
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              6.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                CHANGES, WAIVERS.
              </span>
              . No change or modification of this Agreement shall be valid
              unless it is in writing and signed by all parties. No waiver of
              any provision of this Agreement shall be valid unless in writing
              and signed by the person against whom it is sought to be enforced.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              7.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                TIME IS OF THE ESSENCE.
              </span>
              Time shall be of the essence with regard to every provision of
              this Agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              8.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                <textarea
                  value={postocc?.comments_8}
                  onChange={(e)=>setpostocc({...postocc,comments_8:e.target.value})}
                  style={{ width: "90%", height: 300, resize: "none" }}
                  defaultValue={""}
                />{" "}
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              THE PARTIES ARE ADVISED TO CONSULT AN ATTORNEY BEFORE SIGNING THIS
              AGREEMENT. THIS AGREEMENT IS PROVIDED BY MILFORD REAL ESTATE
              MERELY AS A CONVENIENCE AND MILFORD REAL ESTATE MAKES NO
              GUARANTEES THAT THIS AGREEMENT WILL BE BENEFICIAL TO EITHER PARTY.
              FURTHER, THE PARTIES ACKNOWLEDGE AND UNDERSTAND THAT MILFORD REAL
              ESTATE’S REPRESENTATION AND DUTIES END AS OF THE CLOSING OF THE
              SALE EXCEPT AS IS SPECIFICALLY PROVIDED BY STATUTE
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span>
              Dated this{" "}
              <input
                type="date"
                value={postocc?.dated_this}
                onChange={(e)=>setpostocc({...postocc,dated_this:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              day of
              <input
                type="text"
                value={postocc?.day_of}
                onChange={(e)=>setpostocc({...postocc,day_of:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 200
                }}
              />{" "}
              ,
              <input
                type="text"
                value={postocc?.day_of_}
                onChange={(e)=>setpostocc({...postocc,day_of_:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span style={{paddingRight:".5rem"}}>Seller</span>
                    <img
                      
                      src={user === "seller" ? (val || postocc?.seller1_signature) : postocc?.seller1_signature}
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "100px%"
                      }}
                    />
                    
                  </td>
                  <td>
                    <span style={{paddingRight:".5rem"}}>Buyer</span>
                    <img
                        src={user === "client" ? (val || postocc?.buyer1_signature) : postocc?.buyer1_signature}
                    
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "100px"
                      }}
                    />
                    
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "90%"
                      }}
                    />
                    <br />
                    Seller
                  </td>
                  <td>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "90%"
                      }}
                    />
                    <br />
                    Buyer
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", border: "1px solid #3b0083" }}>
              <tbody>
                <tr>
                  <td>
                    <table
                      style={{
                        borderRight: "1px solid #3b0083",
                        width: "100%",
                        padding: 10
                      }}
                    >
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              STATE OF
                              <input
                                type="text"
                                value={postocc?.state_of_1}
                                onChange={(e)=>setpostocc({...postocc,state_of_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              COUNTY OF
                              <input
                                type="text"
                                value={postocc?.county_of_1}
                                onChange={(e)=>setpostocc({...postocc,county_of_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              The foregoing Agreement was acknowledged before me
                              on
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="text"
                                value={postocc?.foregoing_agreement_1}
                                onChange={(e)=>setpostocc({...postocc,foregoing_agreement_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 400
                                }}
                              />
                              ,by
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SELLER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={postocc?.seller_name1}
                                onChange={(e)=>setpostocc({...postocc,seller_name1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SELLER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={postocc?.seller_name2}
                                onChange={(e)=>setpostocc({...postocc,seller_name2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              NOTARY PUBLIC
                              <input
                                type="text"
                                value={postocc?.notary_public_1}
                                onChange={(e)=>setpostocc({...postocc,notary_public_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SEAL:{" "}
                              <textarea
                                style={{
                                  width: "100%",
                                  height: 300,
                                  border: "none",
                                  outline: "none",
                                  resize: "none"
                                }}
                                defaultValue={""}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table style={{ width: "100%", padding: 10 }}>
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              STATE OF
                              <input
                                type="text"
                                value={postocc?.state_of_2}
                                onChange={(e)=>setpostocc({...postocc,state_of_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              COUNTY OF
                              <input
                                type="text"
                                value={postocc?.county_of_2}
                                onChange={(e)=>setpostocc({...postocc,county_of_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              The foregoing Agreement was acknowledged before me
                              on
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="text"
                                value={postocc?.foregoing_agreement_2}
                                onChange={(e)=>setpostocc({...postocc,foregoing_agreement_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 400
                                }}
                              />
                              ,by
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              BUYER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={postocc?.buyer_name1}
                                onChange={(e)=>setpostocc({...postocc,buyer_name1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              BUYER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={postocc?.buyer_name2}
                                onChange={(e)=>setpostocc({...postocc,buyer_name2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              NOTARY PUBLIC
                              <input
                                type="text"
                                value={postocc?.notary_public_2}
                                onChange={(e)=>setpostocc({...postocc,notary_public_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SEAL:{" "}
                              <textarea
                                style={{
                                  width: "100%",
                                  height: 300,
                                  border: "none",
                                  outline: "none",
                                  resize: "none"
                                }}
                                defaultValue={""}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              NOTE: <br />
              Changes in possession affect insurance rights. Buyer(s) and
              Seller(s) should contact their insurance agents immediately.
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              This is a legally binding contract. If not understood, Buyer(s)
              and Seller(s) may wish to consult an attorney.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ paddingTop: 600 }}>
            <span>
              Other provisions: Earnest deposit to be delivered within (5)
              business days.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}
export default ALApostoccupancy